import { Grid, Paper } from "@material-ui/core";
import React from "react";
import CourseSummaryContent from "../../components/report_course/CourseSummaryContent";

export default function CourseSummary() {
    return (
        <Paper className="p-2 p-lg-3">
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <CourseSummaryContent />
                </Grid>
            </Grid>
        </Paper>
    );
}
